var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 0C17.7912 0 15.9999 1.791 15.9999 3.9999C15.9999 5.8611 17.2773 7.4121 18.9999 7.8582V9.9999C18.9999 10.5522 18.5517 10.9998 18 10.9998H8.0001C6.8691 10.9998 5.838 11.3895 5.0001 12.0234V7.8594C6.7227 7.4121 8.0001 5.8614 8.0001 4.0002C8.0001 1.791 6.2091 0 3.9999 0C1.7907 0 0 1.791 0 3.9999C0 5.8611 1.2774 7.4121 3 7.8573V16.1424C1.2774 16.5876 0 18.1383 0 19.9998C0 22.209 1.791 24 3.9999 24C6.2088 24 7.9998 22.209 7.9998 20.0001C7.9998 18.1386 6.7224 16.5879 4.9998 16.1427V15.9999C4.9998 14.343 6.3435 12.9999 7.9998 12.9999H18C19.6563 12.9999 21 11.6571 21 9.9999V7.8588C22.7217 7.4124 24 5.8617 24 3.9999C24 1.791 22.209 0 20.001 0ZM6 20.0001C6 21.1056 5.1045 21.9999 3.9999 21.9999C2.8953 21.9999 1.9998 21.1056 1.9998 20.0001C1.9998 18.8955 2.8953 18 3.9999 18C5.1045 18 6 18.8955 6 20.0001ZM3.9999 6C2.8953 6 1.9998 5.1045 1.9998 3.9999C1.9998 2.8953 2.8953 1.9998 3.9999 1.9998C5.1045 1.9998 6 2.8956 6 3.9999C6 5.1042 5.1045 6 3.9999 6Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIcon);
export default __webpack_public_path__ + "static/media/VersionIcon.dde389b228500a804be54acfdf87d3f8.svg";
export { ForwardRef as ReactComponent };